<div class="contact-form">
      <form class="form form-custom">
            <div class="item">
                  <label for="nome">Nome</label>
                  <input type="text" [(ngModel)]="dataItem.nome" name="nome" id="nome" placeholder="Nome" /> 
            </div>
            <div class="item">
                  <label for="email">E-mail</label>
                  <input type="text" [(ngModel)]="dataItem.email" name="email" id="email" placeholder="exemplo@exemplo.com.bom" /> 
            </div>
            <div class="item">
                  <label for="mensagem">Mensagem</label>
                  <textarea [(ngModel)]="dataItem.mensagem" name="mensagem" id="mensagem"></textarea> 
            </div>
            <div class="item item-button">
                  <button type="button" (click)="store()">
                        <span>Enviar</span>
                  </button>
            </div>
      </form>
</div>
<loader *ngIf="loader"></loader>
